'use client';

import ForYouCardItem from './for-you-card-item';

import type { IDrama } from '@/apis/drama-mall';

interface IForYouCardListProps {
    list: IDrama[];
}

export default function ForYouCardList(props: IForYouCardListProps) {
    const { list } = props;

    return (
        <div className='mt-[12px] space-y-[12px]'>
            {list.map((item, index) => (
                <ForYouCardItem key={item.title} item={item} position={index + 1} />
            ))}
        </div>
    );
}
